import styled, {css} from 'styled-components';
import {motion} from 'framer-motion';
import FlexBox from "../FlexBox";

/**
 * Drawer Base Styles
 */

const BaseDrawerStyles = css`
    flex: 1 0 auto;
    display: flex;
    outline: 0;
    z-index: 9799;
    position: fixed;
    overflow-y: auto;
    flex-direction: column;
`;

const Drawer__Header = styled.div`
    display: flex;
    flex-shrink: 0;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    height: 62px;
    padding: 0 6px;
    border-bottom: 1px solid ${({theme}) => theme.line};
    background-color: rgba(255, 255, 255, 0.02);
`;

const Drawer__Header__Title = styled.div`
    display: flex;
    align-items: center;
    color: ${({theme}) => theme.color};
    font-size: 17px;
    font-weight: 700;
    letter-spacing: -0.01em;
    padding: 0 12px;
`;

const Drawer__Header__CloseBtn = styled.div`
    color: ${({theme}) => theme.colorMuted};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 40px;
    height: 40px;
    margin-right: 8px;
    border-radius: ${({theme}) => theme.radius.sm};
    transition: color 200ms ${({theme}) => theme.ease.out}, background-color 200ms ${({theme}) => theme.ease.out};

    &:hover {
        color: ${({theme}) => theme.color};
        background-color: rgba(255, 255, 255, 0.08);
    }
`;

const Drawer__Content = styled.div`
    overflow: auto;
    flex-grow: 1;
    overscroll-behavior: contain;
`;

const Drawer__Controls = styled.div`
    display: flex;
    flex-shrink: 0;
    min-height: 50px;
    border-top: 1px solid ${({theme}) => theme.line};
    background-color: rgba(255, 255, 255, 0.02);
`;

const Drawer = styled(motion.div)`
    ${BaseDrawerStyles};
    background-color: ${({theme}) => theme.surface};
    border-left: 1px solid ${({theme}) => theme.line};
    box-shadow: ${({theme}) => theme.shadow.lg};
    overflow: hidden;
`;

const Drawer__Header__Title__Holder = styled(FlexBox)`
    display: flex;
    flex-shrink: 0;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    height: 62px;
`

export const Styled = {
    Drawer,
    Drawer__Header,
    Drawer__Header__Title,
    Drawer__Header__CloseBtn,
    Drawer__Content,
    Drawer__Controls,
    Drawer__Header__Title__Holder,
};
